/**
 * 将 ISO 8601 格式的时间戳转换为指定格式的日期字符串
 * @param timestamp ISO 8601 格式的时间戳
 * @param format 输出格式，可选值：'zh'（中文格式）、'standard'（标准格式）、'date'（仅返回年月日）、'mdhm'（月-日 小时:分钟），默认为 'zh'
 * @returns 格式化后的日期字符串
 */
export const formatDateTime = (
  timestamp: string,
  format: 'zh' | 'standard' | 'date' | 'mdhm' = 'zh',
): string => {
  const date = new Date(timestamp)

  if (format === 'zh') {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    const second = String(date.getSeconds()).padStart(2, '0')

    return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`
  } else if (format === 'date') {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  } else if (format === 'mdhm') {
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    return `${month}-${day} ${hour}:${minute}`
  } else {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    const second = String(date.getSeconds()).padStart(2, '0')

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }
}
